import { ABS_PERIOD_TYPE } from "@va/core-library/period-filter";
import { ChartsPage } from "../models/charts-page.model";
import * as ChartPageActions from "../actions/charts-page.actions";

const initialState: ChartsPage = {
  chartMeta: {
    chartName: null,
    chartTypeId: null,
    filters: {
      currency: null,
      periods: null,
      yearType: null,
      tsYearType: null,
      lines: null,
      revisionPeriod: null,
      scaleType: null,
      tickers: null,
      dataView: null,
    },
  },
  suggestedChartDetails: {
    chartName: "",
    chartTypeId: null,
    lineId: null,
    periods: [],
    otherPeriods: [],
    periodType: "abs",
    is_annual_selected: true,
    ticker: "",
    index: "",
    peers: [],
    scaleType: "",
  },
  chartInstance: {
    instance: null,
  },
};

export function chartsPageReducer(
  state: ChartsPage = initialState,
  action: ChartPageActions.Actions,
) {
  switch (action.type) {
    case ChartPageActions.SET_CHART_META:
      return {
        ...state,
        chartMeta: action.payload,
      };
    case ChartPageActions.SET_SUGGESTED_CHART_DETAILS:
      return {
        ...state,
        suggestedChartDetails: action.payload,
      };
    case ChartPageActions.SET_CHART_INSTANCE:
      return {
        ...state,
        chartInstance: {
          instance: action.payload,
        },
      };
    case ChartPageActions.CLEAR_CHART_FILTERS:
      return {
        ...state,
        chartMeta: {
          chartName: null,
          chartTypeId: null,
          filters: {
            currency: null,
            periods: null,
            otherPeriods: null,
            periodType: ABS_PERIOD_TYPE.dataId,
            yearType: null,
            tsYearType: null,
            lines: null,
            revisionPeriod: null,
            scaleType: null,
            tickers: null,
            dataView: null,
          },
        },
        chartInstance: {
          instance: null,
        },
      };
    case ChartPageActions.SET_CHART_FILTERS:
      return {
        ...state,
        chartMeta: {
          ...state.chartMeta,
          filters: { ...action.payload },
        },
      };
    default:
      return state;
  }
}
